import React, { useEffect, useRef } from 'react';
import bgvideo from './Components/assets/particles-ios.mp4';
import TheContainer from './Components/TheContainer';
import './App.css';

export default function App() {
  const videoRef = useRef(null);

  useEffect(() => {
    const v = videoRef.current;
    if (!v) return;

    v.muted = true; 
    const tryPlay = () => v.play().catch(() => {});


    tryPlay();

   
    const kick = () => tryPlay();
    window.addEventListener('pointerdown', kick, { once: true });
    window.addEventListener('touchstart', kick, { once: true, passive: true });
    window.addEventListener('click', kick, { once: true });

    
    const onVis = () => {
      if (document.visibilityState === 'visible') tryPlay();
    };
    document.addEventListener('visibilitychange', onVis);


    const onCanPlay = () => tryPlay();
    v.addEventListener('canplay', onCanPlay, { once: true });

    return () => {
      window.removeEventListener('pointerdown', kick);
      window.removeEventListener('touchstart', kick);
      window.removeEventListener('click', kick);
      document.removeEventListener('visibilitychange', onVis);
      v.removeEventListener('canplay', onCanPlay);
    };
  }, []);

  return (
    <div className="app-wrapper">
      <div className="video-container">
        <video
          ref={videoRef}
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          controls={false}
          preload="auto"
          className="backgroundVideo"
        >
          <source src={bgvideo} type="video/mp4" />
        </video>
      </div>
      <TheContainer />
    </div>
  );
}
